import { LexbeCase } from '../case.model';
import { Account } from './account.model';
import { Role } from './role.model';

export class User {
	public id: string;
	public userName: string;
	public phoneNumber: string;
	public email: string;
	public emailConfirmed: boolean;
	public phoneNumberConfirmed: boolean;
	public twoFactorEnabled: boolean;
	public roles: Role[];
	public createDate: string;
	public lastLoginDate: string;
	public lastActivityDate: string;
	public accounts: Account[];
	public cases: LexbeCase[];
}
